export const LOADER_ID_LOAD_SEARCH_LOCAL = "search-local/load";
export const LOADER_ID_FETCH_SEARCH_LOCAL = "search-local/fetch";

export const LOADER_ID_LOAD_SEARCH = "search/load";
export const LOADER_ID_FETCH_SEARCH = "search/fetch";

export const LOADER_ID_DICTIONARY_LOAD = "dictionary/load";
export const LOADER_ID_SUGGESTIONS = "search-popup/suggestions";

export const KEY_REDUCER_SEARCH = "search";
